import React from 'react';
import { CtaButton } from './CtaButton';
import { comparison } from '../data/content';
import { useCountdown } from '../hooks/useCountdown';
const keywords = ['SESSIONS.', 'DRILLS.', 'PROGRESSIONS.', 'MANAGEMENT.'];
export function FinalCta() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  return <section className="w-full bg-ink px-5 py-16 text-white sm:px-8" data-id="element-96" data-mp="15d3z65b22omt">
      <div className="mx-auto w-full max-w-2xl" data-id="element-97" data-mp="1jcvb80i0huy6">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-98" data-mp="1jbk7g0okgn72">
          Stop improvising.
          <br data-id="element-99" data-mp="1ec7kzh1lxi50" />
          <span className="text-ember" data-id="element-100" data-mp="1t2omf0e8s81w">Start coaching with a system.</span>
        </h2>

        <p className="mx-auto mt-6 max-w-xl text-center text-base leading-relaxed text-neutral-400" data-id="element-101" data-mp="1t4rdlnr4s787">
          Join hundreds of coaches worldwide who already plan their entire season in under
          5 minutes.
        </p>

        <ul className="mt-8 flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-sm font-extrabold uppercase tracking-[0.08em]" data-id="element-102" data-mp="1x51p1fxozpug">
          {keywords.map((word, index) => <React.Fragment key={word} data-id="element-103" data-mp="s4fkjwuc9z33" data-mpi={index}>
              {index > 0 && <li aria-hidden="true" className="text-neutral-600" data-id="element-104" data-mp="s6s248w6q7fm">
                  /
                </li>}
              <li data-id="element-105" data-mp="122lmufk2578h">{word}</li>
            </React.Fragment>)}
        </ul>
        <p className="mt-4 text-center text-sm font-extrabold uppercase tracking-[0.08em] text-grass" data-id="element-106" data-mp="120inh4x0m1r3">
          All organized.
        </p>

        <div className="mt-10 overflow-hidden rounded-xl border border-white/10" data-id="element-107" data-mp="1b2ruvlwzlf09">
          <table className="w-full border-collapse text-left" data-id="element-108" data-mp="1ftqdwt9d0r77">
            <thead data-id="element-109" data-mp="1fwcufie8ah1k">
              <tr data-id="element-110" data-mp="1ktd03s761hs5">
                <th className="w-1/2 border-b border-r border-white/10 bg-card px-4 py-3 text-[11px] font-extrabold uppercase tracking-[0.1em] text-neutral-300" data-id="element-111" data-mp="1ktwckte1rdys">
                  Without Basketball Ready 360
                </th>
                <th className="w-1/2 border-b border-white/10 bg-card px-4 py-3 text-center text-[11px] font-extrabold uppercase tracking-[0.1em] text-ember" data-id="element-112" data-mp="1tukonijvr491">
                  With Basketball Ready 360
                </th>
              </tr>
            </thead>
            <tbody data-id="element-113" data-mp="3i4puut6dett">
              {comparison.map(row => <tr key={row.without} data-id="element-114" data-mp="3jpkekfhoxro">
                  <td className="border-b border-r border-white/10 px-4 py-3 text-xs text-neutral-400" data-id="element-115" data-mp="3uvr0bmg5jpw4">
                    <span aria-hidden="true" data-id="element-116" data-mp="dezkv3q8ox3c">❌</span> {row.without}
                  </td>
                  <td className="border-b border-white/10 px-4 py-3 text-xs font-bold text-white" data-id="element-117" data-mp="8h7krmffy4o2">
                    <span aria-hidden="true" data-id="element-118" data-mp="mgz2ny92w57c">✅</span> {row.with}
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>

        <div className="mt-10 text-center" data-id="element-119" data-mp="id11li070kbn">
          <p className="text-3xl font-extrabold tabular-nums tracking-tight text-ember" data-id="element-120" data-mp="2o8vd14jif90j">
            {hours}:{minutes}:{seconds}
          </p>
          <p className="mt-1 flex items-center justify-center gap-6 text-[10px] font-bold uppercase tracking-[0.18em] text-neutral-400" data-id="element-121" data-mp="2k8bf3yr441dc">
            <span data-id="element-122" data-mp="2e4eyqflohzyu">HRS</span>
            <span data-id="element-123" data-mp="2e2ltn4qprnsy">MIN</span>
            <span data-id="element-124" data-mp="2e5zsw442zgw6">SEC</span>
          </p>
        </div>

        <div className="relative mt-6 rounded-2xl border border-ember bg-card p-5" data-id="element-125" data-mp="20bflylda6juz">
          <span className="absolute right-0 top-0 rounded-bl-xl rounded-tr-2xl bg-ember px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-126" data-mp="25b1w2lxtbjzk">
            🏆 Complete package
          </span>
          <h3 className="pr-40 text-base font-extrabold uppercase sm:text-lg" data-id="element-127" data-mp="1vegrg1ppgaw9">
            🏆 Basketball Ready 360 + Pro Tactical Kit
          </h3>
          <p className="mt-2 text-sm text-neutral-300" data-id="element-128" data-mp="1hfzb4p24q0od">
            6 Volumes + 5 Bonuses + Pro Tactical Kit
          </p>
          <div className="mt-5 flex items-end justify-between gap-4" data-id="element-129" data-mp="3brxa7y6q5g6j">
            <div data-id="element-130" data-mp="3bpt5je104d57">
              <p className="text-sm text-neutral-500 line-through" data-id="element-131" data-mp="3gqgulu5o6jws">$90</p>
              <p className="text-4xl font-extrabold tracking-tight" data-id="element-132" data-mp="3gonwj394h80e">$27</p>
            </div>
            <span className="mb-1 rounded-full bg-grass/15 px-3 py-1.5 text-[11px] font-extrabold uppercase tracking-[0.1em] text-grass" data-id="element-133" data-mp="1gnpnz8s5u15e">
              Save $63
            </span>
          </div>
        </div>

        <div className="mt-8" data-id="element-134" data-mp="16se7om13slvj">
          <CtaButton label="🚀 YES, I WANT BASKETBALL READY 360" data-id="element-135" data-mp="12p99gvo236cp" />
        </div>

        <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-semibold text-neutral-300" data-id="element-136" data-mp="xpmuohskxi1s">
          <li data-id="element-137" data-mp="symyjerab40c">🔒 Secure Payment</li>
          <li data-id="element-138" data-mp="sxlnvbe6kjj5">⚡ Instant Access</li>
          <li data-id="element-139" data-mp="nztmzrvk5n2t">🛡️ 7-Day Guarantee</li>
        </ul>
        <p className="mt-4 text-center text-xs font-semibold text-neutral-300" data-id="element-140" data-mp="o0lil2p5nkt3">
          💳 Card · GooglePay · ApplePay
        </p>
      </div>
    </section>;
}